import { ValidPosition } from '@bakerweb/models';

export function calcGainLossPercentage(position: ValidPosition) {
  const gainLoss = position.gainLoss || 0;
  const bookValue = position.bookValue || 0;

  if (bookValue === 0) return 0;
  return (gainLoss / bookValue) * 100;
}
